export default "/images/logo.png?8b252523cec912b02eda648a389d1f74";